import React, { useState, useEffect } from 'react';
import { getLatestDraw, getDrawByNumber } from '../services/api';
import { getNumberColor, formatShortDate } from '../utils/storage';

function Header() {
  const [currentDraw, setCurrentDraw] = useState(null);
  const [latestDrawNo, setLatestDrawNo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLatestDraw();
  }, []);

  const fetchLatestDraw = async () => {
    try {
      const response = await getLatestDraw();
      setCurrentDraw(response.data);
      setLatestDrawNo(response.data.drawNo);
    } catch (error) {
      console.error('Failed to fetch latest draw:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrevious = async () => {
    if (!currentDraw || currentDraw.drawNo <= 1) return;

    setLoading(true);
    try {
      const response = await getDrawByNumber(currentDraw.drawNo - 1);
      setCurrentDraw(response.data);
    } catch (error) {
      console.error('Failed to fetch previous draw:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleNext = async () => {
    if (!currentDraw || !latestDrawNo || currentDraw.drawNo >= latestDrawNo) return;

    setLoading(true);
    try {
      const response = await getDrawByNumber(currentDraw.drawNo + 1);
      setCurrentDraw(response.data);
    } catch (error) {
      console.error('Failed to fetch next draw:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <header className="header">
      <h1 className="app-title">🎰 로또 번호 추천</h1>

      {loading ? (
        <div className="latest-draw">
          <p>당첨 번호 불러오는 중...</p>
        </div>
      ) : currentDraw ? (
        <div className="latest-draw">
          <div className="draw-navigation">
            <button
              className="nav-arrow"
              onClick={handlePrevious}
              disabled={currentDraw.drawNo <= 1}
              title="이전 회차"
            >
              ◀
            </button>

            <div className="draw-content">
              <p className="draw-info">
                <strong>제 {currentDraw.drawNo}회</strong> ({formatShortDate(currentDraw.drawDate)})
                {currentDraw.drawNo === latestDrawNo && <span className="latest-badge">최신</span>}
              </p>
              <div className="number-row">
                {currentDraw.numbers.map((num, idx) => (
                  <div
                    key={idx}
                    className="number-ball"
                    style={{ backgroundColor: getNumberColor(num) }}
                  >
                    {num}
                  </div>
                ))}
                <span className="bonus-label">+</span>
                <div
                  className="number-ball bonus"
                  style={{ backgroundColor: getNumberColor(currentDraw.bonusNumber) }}
                >
                  {currentDraw.bonusNumber}
                </div>
              </div>
            </div>

            <button
              className="nav-arrow"
              onClick={handleNext}
              disabled={!latestDrawNo || currentDraw.drawNo >= latestDrawNo}
              title="다음 회차"
            >
              ▶
            </button>
          </div>
        </div>
      ) : (
        <div className="latest-draw">
          <p>당첨 번호를 불러올 수 없습니다.</p>
        </div>
      )}
    </header>
  );
}

export default Header;
